import React from "react"

const SkeletonLoadingvoucher = () => (
  <>
    <div className="d-flex justify-content-center">
      <div className="skeleton skeleton-text-voucher"></div>
    </div>
    <div className="d-flex justify-content-center">
      <div className="skeleton skeleton-text-voucher"></div>
    </div>
    <div className="d-flex justify-content-center">
      <div className="skeleton skeleton-text-voucher"></div>
    </div>
    <div className="d-flex justify-content-center">
      <div className="skeleton skeleton-text-voucher"></div>
    </div>
    <div className="d-flex justify-content-center">
      <div className="skeleton skeleton-text-voucher"></div>
    </div>
    <div className="d-flex justify-content-center">
      <div className="skeleton skeleton-text-voucher"></div>
    </div>
    <div className="d-flex justify-content-center">
      <div className="skeleton skeleton-text-voucher"></div>
    </div>
    <div className="d-flex justify-content-center">
      <div className="skeleton skeleton-text-voucher"></div>
    </div>
    <div className="d-flex justify-content-center">
      <div className="skeleton skeleton-text-voucher"></div>
    </div>
    <div className="d-flex justify-content-center">
      <div className="skeleton skeleton-text-voucher"></div>
    </div>
    <div className="d-flex justify-content-center">
      <div className="skeleton skeleton-text-voucher"></div>
    </div>
    <div className="d-flex justify-content-center">
      <div className="skeleton skeleton-text-voucher"></div>
    </div>
    <div className="d-flex justify-content-center">
      <div className="skeleton skeleton-text-voucher"></div>
    </div>
    <div className="d-flex justify-content-center">
      <div className="skeleton skeleton-text-voucher"></div>
    </div>
  </>
)

export default SkeletonLoadingvoucher
